import axiosInstance from 'api/axiosInstance';
import { RegisteredPlates } from 'containers/pages/CANpark/types/registeredPlates';

export const getRegisteredPlatesByParkingLocation = async (
	parkingLocationId: string,
	filter: {
		search: string;
		showActive: boolean;
		showUpcoming: boolean;
		showExpired: boolean;
		items_per_page: number;
		page: number;
	},
): Promise<RegisteredPlates[]> => {
	try {
		const API_URL = `/api2.0/registeredPlates/getRegisteredPlatesByParkingLocation`;

		// ✅ Build query parameters from filter object
		const params = new URLSearchParams({
			parkingLocationId: parkingLocationId,
			search: filter.search,
			showActive: filter.showActive.toString(),
			showUpcoming: filter.showUpcoming.toString(),
			showExpired: filter.showExpired.toString(),
			items_per_page: filter.items_per_page.toString(),
			page: filter.page.toString(),
		});

		const response = await axiosInstance.get(
			`${API_URL}?${params.toString()}`,
		);

		// ✅ Convert `validFrom` and `validUntil` from ISO 8601 strings to Date objects
		const formattedPlates: RegisteredPlates[] = response.data.map(
			(plate: any) => ({
				id: plate.id,
				licenseNumber: plate.licenseNumber,
				licenseState: plate.licenseState,
				validFrom: new Date(plate.validFrom), // Convert to Date object
				validUntil: new Date(plate.validUntil), // Convert to Date object
				parkingLocationId: plate.parkingLocationId,
			}),
		);

		return formattedPlates;
	} catch (error) {
		console.error('❌ Error fetching registered plates:', error);
		throw error;
	}
};
